<script>
  import './style.scss';
  import template from './template.html';
  import { CloseIcon, CheckCircleIcon  } from '../icons.js';
  import ClickOutside from 'vue-click-outside';
  
  export default {
    template,
    
    props: {
      
      text: [String, Number],
      
      saveUrl: String
    },
    
    methods: {
      
      showEditor () {
        this.oldText = this.editorText;
        this.editorActive = true;
        
        setTimeout(() => this.$refs.edit.focus())
      },
      
      closeEditor () {
        this.editorActive = false;
      },
      
      cancelEditor () {
        this.closeEditor();
        this.editorText = this.oldText;
      },
      
      saveEditor () {
        axios
          .put(this.saveUrl, {
            name: this.editorText
          })
          .then(result => {
            this.closeEditor();
          });
      }
    },
    
    watch: {},
    
    computed: {},
    
    data () {
      return {
        
        editorActive: false,
        
        editorText: this.text,
        
        oldText: ''
      }
    },
    
    components: {
      CheckCircleIcon,
      CloseIcon,
    },
    
    directives: {
      ClickOutside
    },
    
    created () {
      //this.selectedItem = this.items[0];
    }
  }
</script>
